import React from 'react'
import {
  LIVE_CASINO_PROVIDERS,
  LIVE_CASINO_SEARCH_TERMS,
  isLiveCasinoGame,
} from '../../utils/liveCasinoCategories'
import PlayKaroCasinoCatalog from './PlayKaroCasinoCatalog'
import type { PkCasinoCatalogConfig } from './playKaroCasinoCatalogTypes'
import { PK_LC_BANNERS, PK_LC_CATEGORIES, PK_LC_PROVIDERS } from './playKaroLiveCasinoData'

const EXTRA_SEARCH_TERMS = ['cricket', 'crash', 'aviator', 'arcade', 'marble']
const EXTRA_PROVIDER_ALLOW = new Set([
  '2j',
  'v8',
  'mac88',
  'mac88gaming',
  'jili',
  'km',
  'kingmidas',
  'mini',
  'turbogames',
  'microgaming',
  'koolbet',
  'sexy',
])

const LIVE_CASINO_CATALOG: PkCasinoCatalogConfig = {
  catalogId: 'live-casino',
  banners: PK_LC_BANNERS,
  categories: PK_LC_CATEGORIES,
  seedProviders: PK_LC_PROVIDERS,
  showAllFoundProviders: false,
  extraProviderAllow: EXTRA_PROVIDER_ALLOW,
  searchTerms: [...LIVE_CASINO_SEARCH_TERMS, ...EXTRA_SEARCH_TERMS],
  listProviders: LIVE_CASINO_PROVIDERS,
  listTypes: ['slots', 'live-casino'],
  filterGame: isLiveCasinoGame,
  loadingLabel: 'Loading live casino…',
  emptyLabel: 'No live casino games found.',
}

type PlayKaroLiveCasinoProps = {
  preLoginMode?: boolean
  onLoginRequired?: () => void
}

const PlayKaroLiveCasino: React.FC<PlayKaroLiveCasinoProps> = ({ preLoginMode, onLoginRequired }) => (
  <PlayKaroCasinoCatalog
    config={LIVE_CASINO_CATALOG}
    preLoginMode={preLoginMode}
    onLoginRequired={onLoginRequired}
  />
)

export default PlayKaroLiveCasino

export { LIVE_CASINO_CATALOG }
